<!-- eslint-disable no-unused-expressions -->
<!-- eslint-disable vue/max-attributes-per-line -->
<!-- eslint-disable vue/html-indent -->
<template>
  <a-card :bordered="false"
          :bodyStyle="{ padding: '16px 0', height: '100%' }"
          :style="{ height: '100%' }">
    <div class="account-settings-info-view">
      <a-row :gutter="16"
             type="flex"
             justify="center">
        <a-col :md="24"
               :lg="16">
          <a-form-model :model="addOrUpdateForm"
                        ref="addOrUpdateForm"
                        :rules="rules">
            <a-form-model-item :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               label="日期"
                               prop="daysTime">
              <a-radio-group :value="selectDay"
                             @change="changeRadio"
                             button-style="solid"
                             v-model="addOrUpdateForm.degreeType">
                <a-radio-button :value="2">年份</a-radio-button>
                <a-radio-button :value="1">季度</a-radio-button>
                <a-radio-button :value="0">月份</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               label="片区选择"
                               prop="zoneId">
              <a-tree-select :tree-data="zoneTreeData"
                             v-model="addOrUpdateForm.zoneId"
                             style="width: 100%"
                             :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                             :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                             placeholder="请选择片区"
                             allow-clear
                             @select="onSelectArea"
                             tree-default-expand-all></a-tree-select>
            </a-form-model-item>
            <a-form-item label="执行时间"
                         :labelCol="labelCol"
                         :wrapperCol="wrapperCol"
                         prop="execTime">
              <a-date-picker :format="selectFormat"
                             valueFormat="YYYY-MM-DD"
                             placeholder="执行时间"
                             v-model="addOrUpdateForm.execTime"
                             @change="i" />
              <span class="hint"
                    v-if="addOrUpdateForm.degreeType == 2">* 按照月日执行</span>
            </a-form-item>
            <a-form-model-item :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               label="计费水量(m³)"
                               prop="measuredWaterVolume">
              <a-input v-model="addOrUpdateForm.measuredWaterVolume"
                       placeholder="请输入计费水量(m³)" />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               label="免费水量(m³)"
                               prop="freeWater">
              <a-input placeholder="请输入免费水量(m³)"
                       v-model="addOrUpdateForm.freeWater" />
            </a-form-model-item>

            <a-form-model-item :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               label="市政水量可选比例值">
              <a-radio-group v-model="addOrUpdateForm.ratio"
                             @change="changeRate">
                <a-radio v-show="!showZdy"
                         value="0.03">3%</a-radio>
                <a-radio v-show="!showZdy"
                         value="0.04">4%</a-radio>
                <a-radio v-show="!showZdy"
                         value="0.05">5%</a-radio>
                <a-radio v-show="showZdy"
                         :value="textVal">{{ handleFloating }}</a-radio>
              </a-radio-group>
              <a-row>
                <a-col :span="12">
                  <a-slider v-model="textVal"
                            :min="0"
                            :max="0.2"
                            :step="0.01" />
                </a-col>
                <a-col :span="4">
                  <a-input-number v-model="textVal"
                                  :min="0"
                                  :max="0.2"
                                  :step="0.01"
                                  style="margin-left: 16px;width: 65px" />
                </a-col>
              </a-row>
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               label="市政水量(m³)"
                               prop="municipalWaterVolume">
              <a-input placeholder="市政水量(m³)"
                       :disabled="disabled"
                       v-model="addOrUpdateForm.municipalWaterVolume" />
            </a-form-model-item>

            <a-form-model-item :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               label="显示隐藏"
                               prop="daysTime">
              <a-radio-group :value="selectDay"
                             button-style="solid"
                             v-model="addOrUpdateForm.ifDisplay">
                <a-radio-button :value="1">显示</a-radio-button>
                <a-radio-button :value="2">隐藏</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <a-form-model-item>
              <a-button style="margin-left: 200px"
                        type="primary"
                        :loading="confirmLoading"
                        @click="updateData"
                        v-if="formStatus != 'edit'">录入</a-button>
            </a-form-model-item>
          </a-form-model>
        </a-col>
      </a-row>
    </div>
  </a-card>
</template>

<script>
import pick from 'lodash.pick'
import { baseMixin } from '@/store/app-mixin'
import moment from 'moment'
function toMath (val) {
  if (val) {
    return parseFloat(parseFloat(val).toFixed(2))
  } else {
    return parseFloat(0)
  }
}

export default {
  name: 'LeakageRate',
  components: {},
  props: {
    formStatus: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showZdy: false,
      textVal: 0.00,
      queryQuarter: 1,
      selectFormat: 'YYYY-MM-DD',
      selectMode: 'year',
      open: false,
      selectDay: 'year',
      record: {},
      confirmLoading: false,
      disabled: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 }
      },
      addOrUpdateForm: {
        ratio: 0.00,
        daysTime: '',
        zoneId: undefined,
        waterSupply: '',
        measuredWaterVolume: '',
        freeWater: '',
        municipalWaterVolume: '',
        salesVolume: '',
        leakageRate: '',
        degreeType: 2,
        execTime: ''
      },
      rules: {
        execTime: [{ required: true, message: '请选择执行时间' }],
        zoneId: [{ required: true, message: '请选择片区' }],
        waterSupply: [
          { required: true, message: '请输入供水量' },
          { pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入最多两位小数数字' }
        ],
        measuredWaterVolume: [
          { required: true, message: '请输入计费水量' },
          { pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入最多两位小数数字' }
        ],
        freeWater: [
          { required: true, message: '请输入免费水量' },
          { pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入最多两位小数数字' }
        ]
      },
      addUrl: '/pipe-network/zone_leakages_template',
      zoneTreeData: [], // 片区选项
      queryZoneDateUrl: 'zone-metering/zone-metering'
    }
  },
  computed: {
    changeData () {
      const { measuredWaterVolume, freeWater, municipalWaterVolume } = this.addOrUpdateForm
      return {
        measuredWaterVolume,
        freeWater,
        municipalWaterVolume
      }
    },
    handleFloating () {
      const str = this.textVal + ''
      // 输入的值为空、undefined、0时 统一返回0
      if (str == undefined || str == null || str == 0) {
        return 0 + '%'
      }
      // 如果是整数的话只有0和1两种情况 0返回0 1返回100%
      if (!str.toString().split('.')[1]) {
        return str * 100 + '%'
      }
      // 普通情况  获取到小数点后的数字的长度  3
      const decimalLength = str.toString().split('.')[1].length
      // Math.trunc() 保留整数部分  乘最大精度取整   str*10的3次方 获取0.575*1000=575
      const maxFloat = Math.trunc(str * Math.pow(10, decimalLength))
      // 返回拼接的百分比  将最大精度取整后再/长度-2 比如0.575--->57.5   3-2   比如0.8--->8/ 10分之一得到80%
      return maxFloat / Math.pow(10, decimalLength - 2) + '%'
    }
  },
  watch: {
    textVal (dval) {
      console.log(dval)
      if (dval === 0.03 || dval === 0.04 || dval === 0.05) {
        this.showZdy = false
        this.addOrUpdateForm.ratio = dval + ''
      } else {
        this.showZdy = true
        this.addOrUpdateForm.ratio = dval * 1
      }
      const bl = this.addOrUpdateForm.ratio * 1
      this.addOrUpdateForm.municipalWaterVolume = this.addOrUpdateForm.waterSupply * bl
    },
    changeData () {
      this.addOrUpdateForm.salesVolume = toMath(
        toMath(this.addOrUpdateForm.measuredWaterVolume) +
        toMath(this.addOrUpdateForm.freeWater) +
        toMath(this.addOrUpdateForm.municipalWaterVolume)
      )
      this.addOrUpdateForm.leakageRate = toMath(
        parseFloat(
          (this.addOrUpdateForm.waterSupply - this.addOrUpdateForm.salesVolume) / this.addOrUpdateForm.waterSupply
        ) * 100
      )
    },
    // 监听供水量
    'addOrUpdateForm.waterSupply': {
      handler: function (val) {
        console.log('监听供水量', val)
        if (val) {
          this.addOrUpdateForm.municipalWaterVolume = toMath(val * this.addOrUpdateForm.ratio)
          this.addOrUpdateForm.leakageRate = toMath(parseFloat((val - this.addOrUpdateForm.salesVolume) / val) * 100)
        }
      }
    }
  },
  methods: {
    setFormData (obj) {
      obj.ifDisplay = this.addOrUpdateForm.ifDisplay
      this.addOrUpdateForm = obj
    },
    i (date, dateString) {
      console.log(date, '000', dateString, '111')
    },
    changeRadio (e) {
      if (this.addOrUpdateForm.zoneId === undefined) {
        // this.$message.warning('请选择片区！')
      } else {
        this.onSelectArea(this.addOrUpdateForm.zoneId)
      }
    },
    onSelectArea (i) {
      this.addOrUpdateForm.zoneId = i
      console.log(i, '555')
      const ulr = '/pipe-network/zone_leakages_template/find'
      const params = { degreeType: this.addOrUpdateForm.degreeType, zoneId: this.addOrUpdateForm.zoneId }
      this.$http
        .get(ulr, { params })
        .then((res) => {
          this.addOrUpdateForm = {
            degreeType: res.data.degreeType,
            execTime: res.data.execTime,
            zoneId: res.data.zoneId,
            measuredWaterVolume: res.data.measuredWaterVolume,
            freeWater: res.data.freeWater,
            waterSupply: res.data.waterSupply,
            ratio: res.data.ratio,
            municipalWaterVolume: res.data.municipalWaterVolume
          }
        })
        .catch(() => { })
    },
    changeRate () {
      this.textVal = Number(this.addOrUpdateForm.ratio)
      console.log('changeRate', this.addOrUpdateForm.ratio)
      this.addOrUpdateForm.municipalWaterVolume = toMath(this.addOrUpdateForm.waterSupply * this.addOrUpdateForm.ratio)
    },
    getZoneData () {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    panelChange (value) {
      console.log(value)
      this.addOrUpdateForm.daysTime = value
      this.open = false
    },
    openChange (status) {
      if (status) {
        this.open = true
      } else {
        this.open = false
      }
    },
    // 更新数据
    updateData () {
      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          // this.confirmLoading = true
          const params = this.addOrUpdateForm
          // eslint-disable-next-line no-unused-expressions
          typeof params.execTime === 'string' ? '' : (params.execTime = params.execTime.format(this.selectFormat))
          if (this.formStatus === 'edit') {
            this.$http.put(this.addUrl, params)
              .then((res) => {
                if (res.code === 0) {
                  this.$message.success(res.message)
                  this.addOrUpdateForm = {
                    execTime: '',
                    zoneId: '',
                    waterSupply: '',
                    measuredWaterVolume: '',
                    freeWater: '',
                    municipalWaterVolume: '',
                    salesVolume: '',
                    leakageRate: '',
                    degreeType: this.addOrUpdateForm.degreeType
                  }
                  this.selectDay = 'year'
                } else {
                  this.$message.warning(res.message)
                }
                this.$emit('closePopup', false)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            this.$http
              .post(this.addUrl, params)
              .then((res) => {
                if (res.code === 0) {
                  this.$message.success(res.message)
                  this.addOrUpdateForm = {
                    execTime: '',
                    zoneId: '',
                    waterSupply: '',
                    measuredWaterVolume: '',
                    freeWater: '',
                    municipalWaterVolume: '',
                    salesVolume: '',
                    leakageRate: '',
                    degreeType: this.addOrUpdateForm.degreeType
                  }
                  this.selectDay = 'year'
                } else {
                  this.$message.warning(res.message)
                }
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    }
  },
  created () {
    this.getZoneData()
  }
}
</script>

<style lang="less" scoped>
.avatar-upload-wrapper {
  height: 200px;
  width: 100%;
}

.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }

  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
}

.hint {
  color: red;
  font-size: 14px;
  margin-left: 16px;
}
</style>
